import type { ControllerFieldState } from 'react-hook-form';
import { forwardRef } from 'react';
import { useFormContext } from 'react-hook-form';

import {
  Datepicker,
  DatepickerProps,
} from '../../../ToolkitV2/Inputs/Datepicker/Datepicker';

type FinanceDatepickerFieldProps = Omit<
  DatepickerProps,
  'hasError' | 'errorMessage' | 'name'
> &
  ControllerFieldState & { name: string; isOptional?: boolean };

export const FinanceDatepickerField = forwardRef<
  HTMLInputElement,
  FinanceDatepickerFieldProps
>((props, ref) => {
  const { invalid, value, onFocus, ...rest } = props;
  const { clearErrors } = useFormContext();
  return (
    <Datepicker
      {...rest}
      hasError={invalid}
      errorMessage={props.error?.message}
      ref={ref}
      value={value}
      onFocus={(event) => {
        clearErrors(props.name);
        onFocus?.(event);
      }}
    />
  );
});

FinanceDatepickerField.displayName = 'FinanceDatepickerField';
